import Http from "@services/http"

export default class AuthApi {
    static get entity() {
        return ''
    }

    static async csrf() {
        return await Http.get('csrf-cookie')
    }

    static async login(credentials) {
        return await Http.post('login', credentials)
    }

    static async logout() {
        const token = localStorage.getItem('token');
        // console.log('auth api logout');
        return axios({
            method: 'post',
            url: '/api/v2/logout',
            headers: {
                Authorization: 'Bearer ' + token
            }
        });
    }

    static async resetPassword(resetData) {
        return await Http.post('reset-password', resetData)
    }

    static async checkSocialLogin(token) {
        return axios({
            method: 'get',
            url: '/api/v2/user?embed=roles,permissions',
            headers: {
                Authorization: 'Bearer ' + token
            }
        });
    }
}
